/**
 * Opens the specialist finder follow-up modal with symptom context.
 *
 * @return {void}
 */
export function initSpecialistFinderModal() {
	const modal = document.querySelector('[data-modal="specialist-finder"]');

	if (!modal) {
		return;
	}

	const initModalInputMasks = (targetModal) => {
		if (!targetModal || !window.Input) {
			return;
		}

		const inputs = targetModal.querySelectorAll(
			'input:not([data-input-initialized])'
		);

		if (!inputs.length) {
			return;
		}

		inputs.forEach((input) => {
			input.dataset.inputInitialized = 'true';
		});

		new window.Input().listenner(Array.from(inputs));
	};

	/**
	 * @param {CustomEvent} event
	 * @return {void}
	 */
	const handleFinderSubmit = (event) => {
		const detail = event.detail || {};
		const symptoms = Array.isArray(detail.symptoms) ? detail.symptoms : [];

		const symptomsField = modal.querySelector('input[name="symptoms-data"]');
		const sourceField = modal.querySelector('input[name="source"]');

		if (symptomsField) {
			const payload = symptoms
				.map((symptom) => ({
					slug: symptom.slug || '',
					label: symptom.label || symptom.slug || '',
				}))
				.filter((symptom) => symptom.slug || symptom.label);

			symptomsField.value = JSON.stringify(payload);
		}

		if (sourceField) {
			sourceField.value = detail.source || '';
		}

		document.dispatchEvent(
			new CustomEvent('lecardo-vein:modal:open-request', {
				bubbles: true,
				detail: {
					modalId: 'specialist-finder',
				},
			})
		);

		initModalInputMasks(modal);
	};

	document.addEventListener(
		'lecardo-vein:specialist-finder:submit',
		handleFinderSubmit
	);

	document.addEventListener('lecardo-vein:modal:open', (event) => {
		const modalId = event.detail?.modalId;

		if (!['contact', 'callback', 'specialist-finder'].includes(modalId)) {
			return;
		}

		const targetModal = document.querySelector(`[data-modal="${modalId}"]`);

		initModalInputMasks(targetModal);
	});
}
